module.exports = __webpack_public_path__ + "static/media/about-madhuri-compressed.524358f8.jpeg";